import { formatDate } from '../../lib/date-helpers.ts';
import { useResolvedLocale } from '../../lib/hooks/locale.ts';

type DateTimeTextProps = {
    date?: string | number | Date | null;
    format?: Intl.DateTimeFormatOptions;
    children?: string | number | Date | null;
};

export function DateTimeText({
    date,
    children,
    format = {
        dateStyle: 'medium',
        timeStyle: 'medium',
    },
}: DateTimeTextProps) {
    const locale = useResolvedLocale();
    const dateValue = date ?? children;

    if (!dateValue) {
        console.warn('DateTimeText: No date value provided');
        return null;
    }

    const newDate = new Date(dateValue);
    const formattedDate = newDate.toLocaleString(locale, format);

    return <span>{formattedDate}</span>;
}

export function DateText({
    date,
    children,
    format = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    },
}: DateTimeTextProps) {
    const locale = useResolvedLocale();
    const dateValue = date ?? children;

    if (!dateValue) {
        console.warn('DateText: No date value provided');
        return null;
    }

    const formattedDate = formatDate(dateValue, locale, format);

    return <span>{formattedDate}</span>;
}

export function TimeText({
    date,
    children,
    format = {
        timeStyle: 'medium',
    },
}: DateTimeTextProps) {
    const locale = useResolvedLocale();
    const dateValue = date ?? children;

    if (!dateValue) {
        console.warn('TimeText: No date value provided');
        return null;
    }

    const newDate = new Date(dateValue);
    const formattedDate = newDate.toLocaleTimeString(locale, format);

    return <span>{formattedDate}</span>;
}
